// Services
// import { getDischargeStatusPatient } from './getPatientAtribute';

// Interfaces
import { DataElement, DataElementByHour } from '../interfaces/PhysiologicalMonitoring';
import { Case, Patient } from '../interfaces/Patient';
import { TerminalPhase } from '../interfaces/Phase';
import { Score, ScoreParameterSheet } from '../interfaces/Score';

// Other
import moment from 'moment';

export const setColor = (patient: Patient) => { // default set color row
    const color = "#fff";//patient.cases?.[0]?.follow_ups?.find(pfu => pfu.end_date === null)?.profile?.status_color;
    return color;// !== undefined ? '#' + color : undefined;
};

const hasAttributes = (dataElem: DataElement, scoreAttributes: string[]) =>
    Object.keys(dataElem.values).some(keyValue => scoreAttributes.includes(keyValue));



export const getLastTwoElements = (elements: DataElement[], scoreAttributes: string[]) => {
    const MAX_ELEMENTS = 2;
    const MAX_DAYS_BETWEEN_ELEMENTS = 3;
    // selects the last two elements that have at least one of the scoreAttributes. 
    const elementsReturn: DataElement[] = [];

    let i = 0;
    while (
        elementsReturn.length < MAX_ELEMENTS &&
        i < elements.length &&
        moment().diff(moment(elementsReturn[0] ? elementsReturn[0].date : elements[i].date, 'DD-MM-YYYY HH:mm:ss'), 'days') <= MAX_DAYS_BETWEEN_ELEMENTS
    ) {
        if (hasAttributes(elements[i], scoreAttributes)) elementsReturn.push(elements[i]);
        i++;
    }

    return elementsReturn;
};

export const getSheetParametersPoll = (elements: DataElement[], inquiry_id: number) => {
    const sheetParameterIDs = new Set<string>();
    elements.forEach(el => Object.keys(el.values).forEach(key => {
        if (key.includes('_db_id') && el.values[key] === inquiry_id) {
            sheetParameterIDs.add(key.replace('_db_id', ''));
        }
    }));
    return Array.from(sheetParameterIDs);
};


export const getScorePolls = (elements: DataElement[], sheetParameterIDs: string[]) => {
    // return sheetParameterIDs.reduce((accumulator, currentValue) =>
    //     accumulator + (timestamp.values[currentValue] || 0), 0);

    const newScores: { value: number, date: string }[] = [];
    elements.forEach(timestamp => {
        let scoreSum: number | undefined;
        sheetParameterIDs.forEach(id => {
            if (timestamp.values[id] !== undefined) {
                if (scoreSum === undefined) scoreSum = 0;
                scoreSum += timestamp.values[id] || 0;
            }
        });
        if (scoreSum !== undefined) newScores.push({ value: scoreSum, date: timestamp.date });
    });

    return newScores;
};

export const getScoreParameters = (elements: DataElement[], scoresParameters: ScoreParameterSheet[]) => {
    const newScores: { value: number, date: string }[] = [];
    elements.forEach(timestamp => {
        let scoreSum: number | undefined;
        scoresParameters.forEach(param => {
            if (param.sheet_parameter_id && timestamp.values[param.sheet_parameter_id] !== undefined) {
                if (scoreSum === undefined) scoreSum = 0;
                scoreSum += getScoreCV(timestamp.values[param.sheet_parameter_id], param);
            }
        });
        if (scoreSum !== undefined) newScores.push({ value: scoreSum, date: timestamp.date });
    });
    return newScores;
};

export const getTimestampFirstParam = (param_id: string, elementHour: DataElementByHour) => {
    const sortedElements = [...elementHour.elements].sort(
        (a, b) =>
            moment(a.date, 'DD-MM-YYYY HH:mm:ss').valueOf() -
            moment(b.date, 'DD-MM-YYYY HH:mm:ss').valueOf()
    );

    const lastParam = [...sortedElements]
        .reverse()
        .find(element => element.values[param_id] !== undefined);

    return lastParam ?? sortedElements[sortedElements.length - 1];
};

export const getScoreCV = (value: number | null, scoreParameter: ScoreParameterSheet) => {

    if (!scoreParameter || value === null) return 0;

    let score = 0;
    scoreParameter.parameters.forEach(param => {
        if ((param.value_max_range === null || value <= parseFloat(param.value_max_range))
            && (param.value_min_range === null || value >= parseFloat(param.value_min_range))
        ) score = Math.abs(param.puntuation);
    });
    return score;
};

export const getCurrentPhase = (terminalPhases: TerminalPhase[], pps: number) =>
    terminalPhases.find(phase => pps <= phase.pps_max_range && pps >= phase.pps_min_range);

export const getCaseTimeAdmit = (caso: Case | null | undefined) => {
    const startDate = caso?.start_date;
    const endDate = caso?.end_date;
    if (startDate === undefined || endDate !== null || endDate === undefined) return '-';
    const currentDate = moment();
    const days = currentDate.diff(moment(startDate), 'days');
    const accDayHours = days * 24;
    const hours = currentDate.diff(moment(startDate), 'hours') - accDayHours;
    const accDayMinutes = accDayHours * 60;
    const accHourMinutes = hours * 60;
    const minutes = currentDate.diff(moment(startDate), 'minutes') - accDayMinutes - accHourMinutes;
    return `${days > 0 ? days + 'd' : ''} ${hours}h ${minutes}m`;
}

export const getPatientTimeAdmit = (patient: Patient) => {
    return getCaseTimeAdmit(patient.cases?.[0])
};

export const getPatientAdmitDays = (patient: Patient) => {
    const startDate = patient.cases?.[0]?.start_date;
    if (startDate === undefined) return null;
    const currentDate = moment();
    const days = currentDate.diff(moment(startDate), 'days');
    return days;
};

export const getLastAndSecondLastScore = (physiologicalElements: DataElement[] | null, score: Score) => {
    if (!physiologicalElements || physiologicalElements.length === 0) return { secondLastScore: undefined, lastScore: undefined };
    if (score.score_parameters && score.score_parameters.length > 0) {
        const sheetParameterIDs = score.score_parameters.map(param => param.sheet_parameter_id || '');
        const lastTwoElements = getLastTwoElements(physiologicalElements, sheetParameterIDs);
        const [lastScore, secondLastScore] = getScoreParameters(lastTwoElements, score.score_parameters).map(sc => sc.value);
        return { lastScore, secondLastScore };
    }
    if (score.inquiry_id !== null && score.inquiry_id !== undefined) {
        const sheetParameterIDs = getSheetParametersPoll(physiologicalElements, score.inquiry_id);
        const lastTwoElems = getLastTwoElements(physiologicalElements, sheetParameterIDs);
        const [lastScore, secondLastScore] = getScorePolls(lastTwoElems, sheetParameterIDs).map(sc => sc.value);
        return { lastScore, secondLastScore };
    }
    return { secondLastScore: undefined, lastScore: undefined };
};